import { useEffect, useState } from 'react';

export default function usePositionActive(): [
  React.Dispatch<React.SetStateAction<HTMLDivElement | undefined>>,
  React.Dispatch<React.SetStateAction<HTMLSpanElement | undefined>>,
  React.Dispatch<React.SetStateAction<HTMLDivElement | undefined>>
] {
  const [activeRef, setActiveRef] = useState<HTMLDivElement>();
  const [activeLineRef, setActiveLineRef] = useState<HTMLSpanElement>();
  const [informationRef, setInformationRef] = useState<HTMLDivElement>();

  useEffect(() => {
    function handleResize() {
      if (activeRef && activeLineRef) {
        var activeBoundingRect = activeRef.getBoundingClientRect();
        var activeLineBoundingRect = activeLineRef.getBoundingClientRect();
        activeLineRef.style.width = activeLineBoundingRect.right - activeBoundingRect.right + 'px';
        if (informationRef) {
          var informationBoundingRect = informationRef.getBoundingClientRect();
          informationRef.style.top = activeLineBoundingRect.top - informationBoundingRect.height / 1.55 + 'px';
        }
      }
    }
    // Add event listener
    window.addEventListener('resize', handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, [activeRef, activeLineRef, informationRef]); // Empty array ensures that effect is only run on mount

  return [setActiveRef, setActiveLineRef, setInformationRef];
}
